/**
 * File: /home/cordova03/projects/educore_3.5/client/src/app/report_cards/publish_reports/publishReportModule.js
 * Project: /home/cordova03/projects/educore_3.5/client
 * Created Date: Thursday, December 13th 2018, 1:21:09 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Thu Dec 13 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var module = angular.module('PublishReportModule', [
    //import modules
]);

import template from './views/publishReport.html';
import controller from './controllers/publishReportController';
var module = angular.module('publishReports', [
    //import modules
])
module.constant('pulishedReportCardConstants', {
    NO_FEESCHOOLS: ['2FwuqhgeoKt6SQiCG'],
})
.controller('publishReports', controller);

// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('publishReports', {
//             parent: 'app',
//             url: '/publish-reports',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'publishReportCtrl'
//                 }
//             }
//         })

// });


// WEBPACK FOOTER //
// ./src/app/report_cards/publish_reports/publishReportModule.js